export const ShouldShowBundleOnPackingSlipName = 'ShouldShowBundleOnPackingSlip';

export const BundlePackingSlipDisplayMode = Object.freeze({
  ParentOnly: 'parent_only',
  ChildrenOnly: 'children_only',
  ParentAndChildren: 'parent_and_children',
});
export const EnableProductPriceName = 'enableProductPrice';
export const ProductPriceName = 'productPrice';
export const ProductPriceCurrencyCodeName = 'productPriceCurrencyCode';
export const ProductPackagePreference = 'productPackagePreference';
export const ProductPackagingRequirements = 'productPackagingRequirements';
export const ProductDangerousGoodsName = 'productDangerousGoods';
export const ShipStationFulfillmentBarcode = 'shipStationFulfillmentBarcode';
export const MaterialSafetyDataSheet = 'materialSafetyDataSheet';
export const RequireSerialNumberName = 'requireSerialNumber';
export const RequireSerialNumberEnabledValue = 'true';

export const isSerialRequiredProduct = (product) =>
  product?.productOptions?.find((o) => o.name === RequireSerialNumberName)?.value === RequireSerialNumberEnabledValue;
